import { Para, Stack } from '@drycut/ui-components';

type Props = { children: React.ReactNode; title: string; };

export default function Action({ title, children }: Props): React.ReactElement {
  return (
    <Stack gap={2} className="flex-col items-center lg:flex-row lg:items-center">
      <Para className="whitespace-nowrap font-aribaubold">{title}:</Para>

      {children}
    </Stack>
  );
}
